import type { AppliedFrame, AppliedTouchedRow } from './applied-frame';
import { encounterField } from '../../shared/array-types';
import { applyDoorOpeningDecision, type DoorOpeningDecision } from '../geometry/door-opening-plan';
import type { ShapeBlob } from '../../../../ft3d/engine/ft3d-creation-core.js';

export interface DoorOpeningDelta {
  schema: 'ft.ft3d.door-opening.v1'; encounter_id: string; opening_id: string;
  operation: 'move' | 'resize' | 'delete'; opening: DoorOpeningDecision['opening'];
  connection_override: DoorOpeningDecision['connectionOverride']; base_shape_revision: string; shape_revision: string;
}

/** A wire carries only the changed opening and pair override, never the held scene. */
export function doorOpeningFrame(operationId: string, delta: DoorOpeningDelta): AppliedFrame {
  return { kind: 'applied', operation_id: operationId, encounter_id: delta.encounter_id, actor_id: delta.encounter_id,
    rev: 0, member_revs: {}, rows: [], computed: {}, new_entities: [], deletes: [], inputs: { door_opening: delta } };
}

/** Materialize one saved column locally, keeping every unrelated scene object resident. */
export function doorOpeningShapeRow(frame: AppliedFrame, source: unknown): AppliedTouchedRow | null {
  const delta = frame.inputs?.door_opening as DoorOpeningDelta | undefined;
  if (!delta || !frame.operation_id.startsWith('door-opening:') || frame.rows.length || frame.deletes.length
    || frame.new_entities.length || frame.new_inventory?.length || Object.keys(frame.computed).length
    || Object.keys(frame.member_revs).length || frame.computed_delta
    || Object.keys(frame.inputs!).length !== 1 || delta.encounter_id !== frame.encounter_id
    || String(encounterField(source, 'encounter_id') ?? '').toUpperCase() !== frame.encounter_id.toUpperCase()) return null;
  const raw = encounterField<unknown>(source, 'encounter_shape');
  if (!raw) return null;
  const shape = (typeof raw === 'string' ? JSON.parse(raw) : raw) as ShapeBlob;
  const next = shape.openings.some(row => row.id === delta.opening_id)
    ? applyDoorOpeningDecision(shape, delta.opening_id, { opening: delta.opening, connectionOverride: delta.connection_override }) : shape;
  return { table: 'encounters', row_id: frame.encounter_id, partial: true,
    row: { encounter_id: frame.encounter_id, encounter_shape: next === shape && typeof raw === 'string' ? raw : JSON.stringify(next) } };
}
